/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Box, Stack, useStyleConfig, Text} from '@chakra-ui/react'
import Checkbox from '../../../components/checkbox'
import {
    ADD_FILTER,
    REMOVE_FILTER,
} from '@salesforce/retail-react-app/app/pages/product-list/partials/refinements-utils'
import CheckIcon from '../../../components/icons/others/CheckIcon'

const CheckboxRefinements = ({filter, toggleFilter, selectedFilters}) => {
    const {formatMessage} = useIntl()
    const styles = useStyleConfig('RadioRefinements')
    return (
        <Stack {...styles?.stack} spacing={1}>
            {filter?.values?.map((value, idx) => {
                const isChecked = selectedFilters.includes(value.value)
                // Don't display refinements with no results, unless we got there by selecting too
                // many refinements
                if (value.hitCount === 0 && !isChecked) return

                return (
                    <Box key={idx} {...styles?.stackItem}>
                        <Box
                            {...styles?.textContainer}
                            onClick={() =>
                                toggleFilter(value, filter.attributeId, filter.label, isChecked)
                            }
                        >
                            <Text>{value.label}</Text>
                            <Text
                                {...styles?.filterHit}
                                aria-hidden="true" // avoid redundant readout since swatch has aria label
                            >
                                {formatMessage(
                                    {
                                        id: 'checkboxRefinements.hitCount',
                                        defaultMessage: '({checkboxHitCount})',
                                    },
                                    {checkboxHitCount: value.hitCount},
                                )}
                            </Text>
                        </Box>
                        <Checkbox
                            icon={isChecked ? <CheckIcon /> : <></>}
                            isChecked={isChecked}
                            onChange={() =>
                                toggleFilter(value, filter.attributeId, filter.label, isChecked)
                            }
                            aria-label={formatMessage(
                                isChecked ? REMOVE_FILTER : ADD_FILTER,
                                value,
                            )}
                        />
                    </Box>
                )
            })}
        </Stack>
    )
}

CheckboxRefinements.propTypes = {
    filter: PropTypes.object,
    toggleFilter: PropTypes.func,
    selectedFilters: PropTypes.array,
}

export default CheckboxRefinements
